import { render, staticRenderFns } from "./ProjectsPageContainer.vue?vue&type=template&id=78392613&"
import script from "./ProjectsPageContainer.vue?vue&type=script&lang=js&"
export * from "./ProjectsPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports